import { render } from "./DoorIcon.vue?vue&type=template&id=47e01fe0&ts=true"
import script from "./DoorIcon.vue?vue&type=script&lang=ts"
export * from "./DoorIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__